<div class="ttmodal" style="width:400px;">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Change Meter Unit</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body">

    <div>What is the old SMU meter reading? </div>

    <mat-form-field class="input">
      <input matInput placeholder="Old SMU" type="text"  style="background: white; border: 0px solid #ffffff !important; background-color: white!important;" [(ngModel)]="oldMeterSMUReading" [formControl]="oldsmuReadingInput"
        min="preChangeMeterSMU" ngDefaultControl required>
    </mat-form-field>

    <div *ngIf="oldsmuReadingInput.errors && (oldsmuReadingInput.dirty || oldsmuReadingInput.touched)" style="margin-bottom: 20px;">
      <mat-error *ngIf="oldsmuReadingInput.errors.required">Old SMU Reading is required</mat-error>
      <mat-error *ngIf="oldsmuReadingInput.errors.min">Old SMU must be greater than previous SMU</mat-error>
    </div>

    <div>What is the new meter SMU reading? </div>
    <mat-form-field class="input">
      <input matInput placeholder="New SMU" type="text" style="background: white; border: 0px solid #ffffff !important; background-color: white!important;" [(ngModel)]="newSMUReadingOnNewMeter" [formControl]="newsmuReadingInput"
        ngDefaultControl required>
    </mat-form-field>
    <div *ngIf="newsmuReadingInput.errors && (newsmuReadingInput.dirty || newsmuReadingInput.touched)" style="margin-bottom: 20px;">
      <mat-error *ngIf="newsmuReadingInput.errors.required">New SMU Reading is required</mat-error>
    </div>

    <div>What is the date of the replacement? </div>
    <mat-form-field class="input">
      <input matInput [matDatepicker]="myDatepicker" placeholderout="Date of Replacement" readonly [(ngModel)]="dateReplaced"  style="border-bottom: 1px solid white;"   >
      <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #myDatepicker></mat-datepicker>
    </mat-form-field>

  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="warn" [class.loading]="saving" (click)="changeMeterUnitClicked()"   [disabled]= "oldsmuReadingInput.errors || newsmuReadingInput.errors">
      <span class="material-icons button__icon">check</span>
      <span class="button__text">Change Meter Unit</span>
    </button>
  </div>
</div>
